import React, { memo, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getSessionStorage, setSessionStorage } from '../../common/common';
import { addToCTA, getMasterDoctorData } from '../../Store/actions';
import { postAutomatedCtaViewReport } from '../../Store/actions/automatedCta.action';

const UserBehaviourListener = (props) => {
  const { pathname } = useLocation();
  const automated_cta = useSelector((state) => state.automatedCta.automated_cta);
  const user_action_list = useSelector((state) => state.automatedCta.user_action_list);

  const settings = useSelector((state) => state.automatedCta.settings);
  const ctaDataArray = useSelector((state) => state.common.cta_data);
  const is_manual_cta_called = useSelector((state) => state.common.is_manual_cta_called);
  const dispatch = useDispatch();
  const compare = (a, b) => {
    let w_a_1 = a.display * a.specificity;
    let w_a_2 = b.display * b.specificity;
    if (w_a_1 < w_a_2) {
      return -1;
    }
    if (w_a_1 > w_a_2) {
      return 1;
    }
    return 0;
  };
  const sortArrayByWeightedAverage = (array, cb) => {
    //console.log('BEFORE SORT', array);
    let tempArr = [];
    if (array?.length > 0) {
      tempArr = array;
    }

    tempArr.sort(compare);

    cb(tempArr);
  };
  const breakArrayToParts = (array, breakPoint) => {
    if (breakPoint >= array.length) {
      return [array];
    } else if (breakPoint == 0) {
      return [false, array];
    } else {
      let arrayToCut = [...array];
      let firstPart = arrayToCut.slice(0, breakPoint);
      let secondPart = arrayToCut.slice(breakPoint, arrayToCut.length);
      return [firstPart, secondPart];
    }
  };
  const countOccurences = (myArray) => {
    if (myArray && myArray?.length > 0) {
      let countObject = myArray.reduce((count, currentValue) => {
        return count[currentValue] ? ++count[currentValue] : (count[currentValue] = 1), count;
      }, {});
      return countObject;
    } else {
      return false;
    }
  };
  const behaviourObjects = () =>
    getSessionStorage('behaviour_objects', false)
      ? JSON.parse(getSessionStorage('behaviour_objects', '[]'))
      : null;
  const setBehaviourObjects = (paramObj, cb) => {
    let object = {
      ...paramObj
      // specialities: paramObj.specialities ? paramObj.specialities?.split(',') : []
    };

    if (!behaviourObjects()?.some((_obj) => _obj.id == object.id)) {
      let obj = {
        id: object.id,
        specialities: object.specialities,
        doctors: object.doctors,
        type: object.type
      };

      let array_to_store =
        behaviourObjects() && behaviourObjects()?.length > 0 ? [...behaviourObjects(), obj] : [obj];

      setSessionStorage('behaviour_objects', JSON.stringify(array_to_store));
    } else if (behaviourObjects()?.some((_obj) => _obj.id == object.id)) {
      let behaviours = behaviourObjects();
      let index = behaviours.findIndex((each_obj) => each_obj.id == object.id);
      let array_to_store = [...behaviourObjects()];
      array_to_store[index] = object;
      setSessionStorage('behaviour_objects', JSON.stringify(array_to_store));
    }

    setTimeout(() => {
      cb && cb();
    }, 500);
  };
  const calculateFrequencyOfHold = (entity_id, entity_value) => {
    let ctaHoldList = getSessionStorage('cta_to_hold', false)
      ? JSON.parse(getSessionStorage('cta_to_hold', '[]'))
      : [];
    //console.log('FREQUENCY', ctaHoldList, entity_id, entity_value);
    if (ctaHoldList?.length > 0) {
      let isAlreadyPresent = ctaHoldList?.some(
        (_holdCta) => _holdCta.entity_id == entity_id && _holdCta.entity_value == entity_value
      );

      let freq = isAlreadyPresent
        ? ctaHoldList?.find(
            (_holdCta) => _holdCta.entity_id == entity_id && _holdCta.entity_value == entity_value
          )?.frequency || 0
        : 0;
      return freq;
    } else {
      return 0;
    }
  };
  const removeFromHold = (ctaToShow) => {
    let ctaHoldList = getSessionStorage('cta_to_hold', false)
      ? JSON.parse(getSessionStorage('cta_to_hold', '[]'))
      : [];
    if (ctaHoldList?.length > 0) {
      let removedArray = ctaHoldList?.filter(
        (_eachCta) =>
          !ctaToShow?.some(
            (_showcta) =>
              _showcta.entity_id == _eachCta?.entity_id &&
              _showcta.entity_value == _eachCta?.entity_value
          )
      );
      setSessionStorage('cta_to_hold', JSON.stringify(removedArray));
    }
  };
  const triggerOccurence = (subscribeCta, settings, user_action_list) => {
    //console.table('USER_ACTION_LIST_REDUCER', user_action_list);
    const {
      MAX_STREAK,
      MAX_AUTOMATED_CTA,
      SPECIALITY_SPECIFICITY,
      DOCTOR_SPECIFICITY,
      SERVICE_SPECIFICITY
    } = settings;

    const manual_cta_length = ctaDataArray?.length || 0;
    let count = 0;
    const userBehaviours = behaviourObjects();
    let CTA_DISPLAY_LIST = [];
    const CTA_SHOWN_LIST = getSessionStorage('cta_shown', false)
      ? JSON.parse(getSessionStorage('cta_shown', '[]'))
      : [];
    //console.table('CTA_DISPLAY', CTA_DISPLAY_LIST);
    if (userBehaviours && userBehaviours?.length > 0) {
      let speciality_array =
        userBehaviours?.length > 0 ? userBehaviours?.map((_u) => _u.specialities)?.flat() : [];
      let doctors_array =
        userBehaviours?.length > 0 ? userBehaviours?.map((_u) => _u.doctors)?.flat() : [];
      let service_array = userBehaviours?.reduce((total_array = [], curElem) => {
        //console.log('USER_BEHAVIOUR', total_array);
        if (curElem?.type) {
          return [...total_array, curElem?.type];
        }
      }, []);
      //console.log('USER_BEHAVIOUR_SPECIALITY_ARRAY', speciality_array);
      //console.log('USER_BEHAVIOUR_DOCTOR_ARRAY', doctors_array);
      //console.log('USER_BEHAVIOUR_SERVICE_ARRAY', service_array);

      if (speciality_array && speciality_array?.length > 0) {
        const specialityCountObject = countOccurences(speciality_array);

        for (const speciality in specialityCountObject) {
          let countCalculated = calculateFrequencyOfHold(1, speciality);
          if (specialityCountObject[speciality] + countCalculated >= MAX_STREAK) {
            // alert('Speciality 3 time ' + speciality);
            if (
              !user_action_list?.some(
                (_action) =>
                  _action.cta_type_id == 1 &&
                  _action.entity_id == 1 &&
                  _action.entity_value == speciality
              )
            ) {
              const specialityApiObj = subscribeCta.some((cta) => cta.entity_id == 1)
                ? subscribeCta.find((cta) => cta.entity_id == 1)
                : null;
              // specialityApiObj && dispatch(addToCTA([{ ...specialityApiObj, speciality }]));
              let temp = [...userBehaviours];
              for (let index = 0; index < temp.length; index++) {
                let eachObj = temp[index];

                if (eachObj.specialities.indexOf(speciality) > -1) {
                  eachObj.specialities = eachObj.specialities?.filter((elem) => elem != speciality);
                }
              }
              setSessionStorage('behaviour_objects', JSON.stringify(temp));
              if (!CTA_DISPLAY_LIST.some((i) => i.entity_id == 1 && i.entity_value == speciality)) {
                let isAlreadyShown = CTA_SHOWN_LIST.some(
                  (i) => i.entity_id == 1 && i.entity_value == speciality
                );

                let alreadyShownCta = isAlreadyShown
                  ? CTA_SHOWN_LIST.find((i) => i.entity_id == 1 && i.entity_value == speciality)
                  : null;
                CTA_DISPLAY_LIST.push({
                  ...specialityApiObj,
                  cta_type: 'subscribe',
                  entity_value: speciality,
                  display: isAlreadyShown ? alreadyShownCta?.display || 1 : 1,
                  specificity: SPECIALITY_SPECIFICITY
                });
              }

              count++;

              break;
            } else {
              let temp = [...userBehaviours];
              for (let index = 0; index < temp.length; index++) {
                let eachObj = temp[index];

                if (eachObj.specialities.indexOf(speciality) > -1) {
                  eachObj.specialities = eachObj.specialities?.filter((elem) => elem != speciality);
                }
              }
              setSessionStorage('behaviour_objects', JSON.stringify(temp));
              continue;
            }
          }
        }
      }
      if (doctors_array && doctors_array?.length > 0) {
        const doctorsCountObject = countOccurences(doctors_array);

        for (const doctor in doctorsCountObject) {
          let countCalculated = calculateFrequencyOfHold(2, doctor);
          if (doctorsCountObject[doctor] + countCalculated >= MAX_STREAK) {
            // alert('Doctor 3 time ' + doctor);
            if (
              !user_action_list?.some(
                (_action) =>
                  _action.cta_type_id == 1 &&
                  _action.entity_id == 2 &&
                  _action.entity_value == doctor
              )
            ) {
              const doctorApiObj = subscribeCta.some((cta) => cta.entity_id == 2)
                ? subscribeCta.find((cta) => cta.entity_id == 2)
                : null;
              // doctorApiObj && dispatch(addToCTA([{ ...doctorApiObj, doctor_id: doctor }]));
              let temp = [...userBehaviours];
              for (let index = 0; index < temp.length; index++) {
                let eachObj = temp[index];

                if (eachObj.doctors.indexOf(doctor) > -1) {
                  eachObj.doctors = eachObj.doctors?.filter((elem) => elem != doctor);
                }
              }
              setSessionStorage('behaviour_objects', JSON.stringify(temp));
              if (!CTA_DISPLAY_LIST.some((i) => i.entity_id == 2 && i.entity_value == doctor)) {
                let isAlreadyShown = CTA_SHOWN_LIST.some(
                  (i) => i.entity_id == 2 && i.entity_value == doctor
                );

                let alreadyShownCta = isAlreadyShown
                  ? CTA_SHOWN_LIST.find((i) => i.entity_id == 2 && i.entity_value == doctor)
                  : null;
                CTA_DISPLAY_LIST.push({
                  ...doctorApiObj,
                  cta_type: 'subscribe',
                  entity_value: doctor,
                  display: isAlreadyShown ? alreadyShownCta?.display || 1 : 1,
                  specificity: DOCTOR_SPECIFICITY
                });
              }
              count++;
              break;
            } else {
              let temp = [...userBehaviours];
              for (let index = 0; index < temp.length; index++) {
                let eachObj = temp[index];

                if (eachObj.doctors.indexOf(doctor) > -1) {
                  eachObj.doctors = eachObj.doctors?.filter((elem) => elem != doctor);
                }
              }
              setSessionStorage('behaviour_objects', JSON.stringify(temp));
              continue;
            }
          }
        }
      }
      if (service_array && service_array?.length > 0) {
        //console.log('_SERVICE', service_array);
        const serviceCountObject = countOccurences(service_array);

        for (const service in serviceCountObject) {
          let countCalculated = calculateFrequencyOfHold(3, service);
          //console.log('SERVICE FREQUENCY COUNT', countCalculated);
          if (serviceCountObject[service] + countCalculated >= MAX_STREAK) {
            // alert('Service 3 time ' + service);
            if (
              !user_action_list?.some(
                (_action) =>
                  _action.cta_type_id == 1 &&
                  _action.entity_id == 3 &&
                  _action.entity_value == service
              )
            ) {
              const serviceApiObj = subscribeCta.some((cta) => cta.entity_id == 3)
                ? subscribeCta.find((cta) => cta.entity_id == 3)
                : null;
              // serviceApiObj && dispatch(addToCTA([{ ...serviceApiObj, service }]));
              let temp = [...userBehaviours];
              for (let index = 0; index < temp.length; index++) {
                let eachObj = temp[index];
                //console.log('EACH SERVICE OBJ', eachObj);
                if (eachObj.type == service) {
                  eachObj.type = '';
                }
              }
              setSessionStorage('behaviour_objects', JSON.stringify(temp));
              if (!CTA_DISPLAY_LIST.some((i) => i.entity_id == 3 && i.entity_value == service)) {
                let isAlreadyShown = CTA_SHOWN_LIST.some(
                  (i) => i.entity_id == 3 && i.entity_value == service
                );

                let alreadyShownCta = isAlreadyShown
                  ? CTA_SHOWN_LIST.find((i) => i.entity_id == 3 && i.entity_value == service)
                  : null;
                let objectToPush = {
                  ...serviceApiObj,
                  cta_type: 'subscribe',
                  entity_value: service,
                  display: isAlreadyShown ? alreadyShownCta?.display || 1 : 1,
                  specificity: SERVICE_SPECIFICITY
                };
                //console.log('OBJECT_TO_PUSH', objectToPush);
                CTA_DISPLAY_LIST.push(objectToPush);
              }

              count++;
              break;
            } else {
              let temp = [...userBehaviours];
              for (let index = 0; index < temp.length; index++) {
                let eachObj = temp[index];
                //console.log('EACH SERVICE OBJ', eachObj);
                if (eachObj.type == service) {
                  eachObj.type = '';
                }
              }
              setSessionStorage('behaviour_objects', JSON.stringify(temp));
              continue;
            }
          }
        }
      }
    }
    //console.table('CTA_DISPLAY_COUNT', CTA_DISPLAY_LIST);
    if (count > 0) {
      // //console.table('CTA_DISPLAY_LIST', sortArrayByWeightedAverage(CTA_DISPLAY_LIST));
      sortArrayByWeightedAverage(CTA_DISPLAY_LIST, (sortedArray) => {
        //console.table('SORTED_ARRAY', sortedArray);
        const chunkedArrays = breakArrayToParts(
          sortedArray,
          manual_cta_length >= MAX_AUTOMATED_CTA ? 0 : MAX_AUTOMATED_CTA - manual_cta_length
        );
        //console.log('CHUNKED ARRAY', chunkedArrays);
        if (chunkedArrays[0]) {
          let ctaToShow = chunkedArrays[0];
          //console.table('CTA_DISPLAY_TO_SHOW', ctaToShow);

          if (ctaToShow?.length > 0) {
            dispatch(addToCTA(ctaToShow));
            let temp_Arr = [...ctaToShow];
            removeFromHold(ctaToShow);
            temp_Arr.forEach((_cta) => {
              _cta.display += 1;
              dispatch(postAutomatedCtaViewReport(_cta?.id, _cta?.entity_value, () => {}));
            });
            temp_Arr.forEach((_cta) => {
              if (
                !CTA_SHOWN_LIST?.some(
                  (_shownCta) =>
                    _shownCta.entity_id == _cta.entity_id &&
                    _shownCta.entity_value == _cta.entity_value
                )
              ) {
                CTA_SHOWN_LIST.push(_cta);
              } else {
                let indexToChange = CTA_SHOWN_LIST?.findIndex(
                  (_shownCta) =>
                    _shownCta.entity_id == _cta.entity_id &&
                    _shownCta.entity_value == _cta.entity_value
                );
                CTA_SHOWN_LIST[indexToChange].display = _cta.display;
              }
            });
            setSessionStorage('cta_shown', JSON.stringify(CTA_SHOWN_LIST));
          }
        }
        if (chunkedArrays[1]) {
          let ctaToHold = chunkedArrays[1];
          //console.table('CTA_DISPLAY_TO_HOLD', ctaToHold);
          // setSessionStorage('cta_to_hold', JSON.stringify(ctaToHold));
          let CTA_HOLD_LIST = getSessionStorage('cta_to_hold', false)
            ? JSON.parse(getSessionStorage('cta_to_hold', '[]'))
            : [];

          ctaToHold.forEach((_cta) => {
            if (
              !CTA_HOLD_LIST?.some(
                (_holdCta) =>
                  _holdCta.entity_id == _cta.entity_id && _holdCta.entity_value == _cta.entity_value
              )
            ) {
              CTA_HOLD_LIST.push({ ..._cta, frequency: 1 });
            } else {
              let indexToChange = CTA_HOLD_LIST?.findIndex(
                (_shownCta) =>
                  _shownCta.entity_id == _cta.entity_id &&
                  _shownCta.entity_value == _cta.entity_value
              );
              CTA_HOLD_LIST[indexToChange].frequency += 1;
            }
          });
          setSessionStorage('cta_to_hold', JSON.stringify(CTA_HOLD_LIST));
        }
      });
    }
  };
  useEffect(() => {
    if (props?.extraData?.isSessionReserved) {
      if (
        !user_action_list?.some(
          (_act) => _act.cta_type_id == 2 && _act.entity_value == props?.id
        ) &&
        !ctaDataArray?.some(
          (_act) => _act.cta_type_id == 2 && _act.entity_id == 4 && _act.session_id == props?.id
        )
      ) {
        // alert('session reserved');
        props?.onAction && props?.onAction();
        const sessionReserveCta = automated_cta?.filter((cta) => cta.cta_type_id == 2) || [];

        if (sessionReserveCta?.length > 0) {
          let temp_Arr = [...sessionReserveCta];
          temp_Arr.forEach((_session) => {
            _session.session_id = props?.id;
            _session.cta_type = 'session_reserve';
            dispatch(postAutomatedCtaViewReport(_session?.id, _session?.session_id, () => {}));
          });
          dispatch(addToCTA(temp_Arr));
        }
      }
    }
  }, [props?.extraData?.isSessionReserved, automated_cta, user_action_list, ctaDataArray]);

  useEffect(() => {
    if (props?.extraData?.isCertificateViewed) {
      // alert('certificate viewed for 30 seconds');

      if (
        !user_action_list?.some(
          (_act) => _act.cta_type_id == 3 && _act.entity_value == props?.certificate_id
        )
      ) {
        props?.onAction && props?.onAction();
        const certificateCta = automated_cta?.filter((cta) => cta.cta_type_id == 3) || [];
        //console.log('CERTIFICATE', props?.extraData);
        if (certificateCta?.length > 0) {
          let temp_Arr = [...certificateCta];
          temp_Arr.forEach((_cert) => {
            if (_cert?.position == 'before_content' || _cert?.position == 'after_content') {
              _cert.session = props?.extraData?.session_details;
              _cert.certificate_id = props?.certificate_id;
              _cert.cta_type = 'certificate';
              dispatch(postAutomatedCtaViewReport(_cert.id, props?.certificate_id, (res) => {}));
            }
          });
          dispatch(addToCTA(temp_Arr));
        }
      }
    }
  }, [props?.extraData?.isCertificateViewed, automated_cta, user_action_list]);
  useEffect(() => {
    if (props.id && automated_cta?.length > 0 && is_manual_cta_called && settings) {
      //console.log('BEHAVIOUR_PROPS', props);
      // //console.log('USER_ACTION_LIST_REDUCER', user_action_list);
      const subscribeCta = automated_cta?.filter((cta) => cta.cta_type_id == 1) || [];
      setBehaviourObjects(props, () => triggerOccurence(subscribeCta, settings, user_action_list));
    }

    return () => {};
  }, [props.id, automated_cta, is_manual_cta_called, settings]);

  return <></>;
};

export default memo(UserBehaviourListener);
